import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
function Mobile_career() {
  const canonicalUrl = 'https://www.internselite.net/Careers'
  return (
    <div>
      <Helmet>
        <title>
          Careers | InternsElite: Join Our Team and Grow Your Career
        </title>
        <meta
          name="description"
          content="Join InternsElite and grow your career with us. Explore our current job openings and career opportunities. Become part of a dynamic team dedicated to providing top-notch online internships and professional courses. Apply now and take the next step in your professional journey."
        />
        <meta
          name="keywords"
          content="careers, job openings, work at InternsElite, career opportunities, join our team, InternsElite careers"
        />
        <meta
          property="og:title"
          content="Careers | InternsElite: Join Our Team and Grow Your Career"
        />
        <meta
          property="og:description"
          content="Join InternsElite and grow your career with us. Explore our current job openings and career opportunities. Become part of a dynamic team dedicated to providing top-notch online internships and professional courses. Apply now and take the next step in your professional journey."
        />
        <meta property="og:url" content="https://internselite.net/Careers" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Careers | InternsElite: Join Our Team and Grow Your Career"
        />
        <meta
          name="twitter:description"
          content="Join InternsElite and grow your career with us. Explore our current job openings and career opportunities. Become part of a dynamic team dedicated to providing top-notch online internships and professional courses. Apply now and take the next step in your professional journey."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="container pt-5 mt-5 d-xl-none d-md-block program_mobile_text">
        <h1 className="display-5 text-center pt-5">Join Our Community</h1>
        <div className="mb-4 mt-4">
          <div className="text-center">
            <h5>Become IntersElite’s Campus Ambassador</h5>
            <p>
              You will act as the face of InternsElite on your university's
              campus and represent our company there. In this position, you will
              play a crucial role in managing InternsElite's Career-defining
              programs for underprepared college students who are looking to
              build a more impressive resume. An interesting opportunity to gain
              exposure in the corporate world and generate revenue while you
              read! And the average time investment is less than 2 hours per
              week.
            </p>
            <div>
              <Link to="/Campus-Ambassador-Program">
                <button className="shadow-sm fs-6 px-4 pt-1 pb-2 Navbar_button">
                  Fill The Form
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="border-top pt-4 pb-5">
          <div className="text-center">
            <h5>Looking For A Job?</h5>
            <p>
              At InternsElite, you'll have the opportunity to grow
              professionally, personally, and environmentally while still
              earning a competitive salary.Please fill out the form and attach
              your CV/portfolio; we will get in touch with you as soon as
              possible.
            </p>
            <div>
              <Link to="/Business-Development-Associate">
                <button className="shadow-sm fs-6 px-4 pt-1 pb-2 Navbar_button">
                  Fill The Form
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile_career
